import React, { Component } from 'react';
import { Row, Table, Button, Popconfirm } from 'antd';
import { api, app } from "../../app";
import PropTypes from 'prop-types';
import utils from "../../utils";

class ReHonorCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_loading: false,
            auditList: [],
        };
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = (data, cb) => {
        if (this._isMounted) {
            this.setState(data, () => {
                if (cb) cb();
            });
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据源
     */
    dataSource = () => {
        this.setData({ data_loading: true }, async () => {
            const params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            };
            let { flag, data, msg } = await app.post(api.TvhpList, params);
            if (flag !== 1) {
                app.alert(msg, "error");
                data = [];
            }
            this.setData({ auditList: utils.addArrayKey(data), data_loading: false });
        });
    }

    render() {
        const columns = [
            {
                title: '序号',
                dataIndex: 'xuhao',
                key: 'xuhao',
                width: '5%',
                render(text, record, index) {
                    return index + 1;
                }
            },
            {
                title: '姓名',
                dataIndex: 'vname',
                key: 'vname',
                width: '10%'
            },
            {
                title: '队员编号',
                dataIndex: 'bsrno',
                key: 'bsrno',
                width: '10%'
            },
            {
                title: '所属队伍',
                dataIndex: 'teamname',
                key: 'teamname',
                width: '20%'
            },
            {
                title: '荣耀编码',
                dataIndex: 'hp_bsrno',
                key: 'hp_bsrno',
                width: '15%'
            },
            {
                title: '队管理员审核',
                dataIndex: 'team_header_audit',
                key: 'team_header_audit',
                width: '10%',
                render: (text) => {
                    switch (text) {
                        case "1":
                            return (<span>审核通过</span>);
                        case "2":
                            return (<span>审核不通过</span>);
                    }
                    return (<span>待审核</span>);
                }
            },
            {
                title: '提交时间',
                dataIndex: 'submit_time',
                key: 'submit_time',
                width: '15%'
            },
            {
                title: '操作',
                dataIndex: 'id',
                key: 'sjglycz',
                width: '15%',
                render: (text) => {
                    const reviewInfo = {
                        id: text,
                        uri: api.StatusAudit,
                        id_key: "id",
                        source: () => this.dataSource(),
                    };
                    return (
                        <Row type="flex" justify="center">
                            <Popconfirm placement="bottom"
                                title="确定审核通过吗？"
                                cancelText="取消"
                                okText="确定"
                                onConfirm={() => this.props.successReview(1, "", reviewInfo)}
                            >
                                <Button size="small" type="primary" style={{ marginRight: 10 }}>通过</Button>
                            </Popconfirm>
                            <Button size="small" type="danger" style={{ marginLeft: 10 }} onClick={() => {
                                this.props.failReview(reviewInfo)
                            }} ghost>不通过</Button>
                        </Row>
                    )
                }
            },
        ],
            { auditList, data_loading } = this.state;
        return (
            <Table columns={columns}
                locale={app.tbLocale(data_loading)}
                loading={data_loading}
                dataSource={auditList}
                scroll={{ y: 'calc(100% - 38px)' }}
                pagination={false}
                size="small"
            />
        );
    }
}

ReHonorCode.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReHonorCode;



// WEBPACK FOOTER //
// ./src/routes/review/ReHonorCode.jsx